import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { TenantProvider } from "@/contexts/TenantContext";
import { ScenarioProvider } from "@/contexts/ScenarioContext";
import { I18nProvider } from "@/contexts/I18nContext";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Network from "@/pages/Network";
import SOC from "@/pages/SOC";
import Analytics from "@/pages/Analytics";
import Telemetry from "@/pages/Telemetry";
import Agents from "@/pages/Agents";
import "@/index.css";

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route element={<AppLayout />}>
        <Route path="/cockpit" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/network" element={<Network />} />
        <Route path="/soc" element={<SOC />} />
        <Route path="/playbooks" element={<Navigate to="/agents?tab=playbooks" replace />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/telemetry" element={<Telemetry />} />
        <Route path="/agents" element={<Agents />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <AuthProvider>
          <TenantProvider>
            <ScenarioProvider>
              <Router />
              <Toaster theme="dark" position="top-right" />
            </ScenarioProvider>
          </TenantProvider>
        </AuthProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}
